import { TranslationKey } from './../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { BaseFilterProps } from '../common/BaseFilter';
import { UserFilter } from '../UserFilter/UserFilter';

export class CreatedByFilter extends UserFilter {
  toLabel(props: BaseFilterProps): string {
    return t(TranslationKey.createdBy).singular.label;
  }
}
